import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Truck, Loader2, ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (e) {
      setError(apiErr(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] p-6">
      <div className="w-full max-w-sm animate-slide-up">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#FF6500] text-white"><Truck size={24} /></div>
          <span className="font-head text-xl font-extrabold text-[#0B192C]">GS Pacific ePOD</span>
        </div>
        <form onSubmit={submit} className="rounded-xl border border-slate-200 bg-white p-6">
          <h2 className="font-head text-xl font-bold text-[#0B192C]">Set a new password</h2>
          {!token && <p className="mt-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">Missing reset token. Use the link from your email.</p>}
          <input
            data-testid="reset-password-input"
            type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-4 w-full rounded-xl border border-slate-300 px-4 py-3 text-sm outline-none focus:border-[#0B192C]"
            placeholder="New password"
          />
          {error && <div className="mt-3 rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</div>}
          <button data-testid="reset-submit-button" disabled={loading || !token} className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-[#0B192C] py-3 font-bold text-white tap-shrink disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Reset password"}
          </button>
          <Link to="/login" className="mt-4 flex items-center justify-center gap-1.5 text-sm font-semibold text-[#1E3E62] hover:underline">
            <ArrowLeft size={16} /> Back to sign in
          </Link>
        </form>
      </div>
    </div>
  );
}
